import React from "react"
import { Box } from "@mui/material"

import { AppAntSwitch } from "@components"
import { reportListStatusFilter } from "Pages/ReportsAlerts/Reports/@signals"
import { useReportHandleStatus } from "Pages/ReportsAlerts/Reports/@hooks"


export default function statusColumn() {
	return [{
		name: 'enabled',
		label: 'Off/On',
		options: {
			display: 'excluded',
			filterType: 'checkbox',
			filterList: reportListStatusFilter.value,
			customBodyRowRender: value => value ? 'Enabled' : 'Disabled'
		}
	}, {
		name: 'enabled',
		label: 'Off/On',
		options: {
			filter: false,
			customBodyRowRender: (value, rowData) => {
				return <Box sx={{ display: 'flex', justifyContent: 'center' }}>
					<StatusSwitch checked={value} idReport={rowData.idReport} rowData={rowData}/>
				</Box>
			}
		}
	}]
}

const StatusSwitch = ({ checked, idReport, rowData }) => {
	const { handleStatus } = useReportHandleStatus(idReport, rowData)

	return <AppAntSwitch
		checked={checked}
		onChange={() => handleStatus(!checked)}
	/>
}